import React, { useEffect, useState, useContext } from "react";
import "./AddEditThingType.style.css";
import { Tabs, Tab } from "react-bootstrap";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import UserContext from "common/Context/UserContext";
import CreatableSelect from "react-select/creatable";
import ThingTypeImage from "../ThingTypeImage/ThingTypeImage";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Activestatus from "../../../../../assets/active.svg";
import inActivestatus from "../../../../../assets/Inactive.svg";

const AddEditThingType = ({
  selectedView,
  selectedThingType,
  handleCancel,
  isEdit = false,
  addNewThingType,
  updateThingType,
  fetchAllImages,
  addNewThingTypeImage,
  updateThingTypeImage,
  handleEditThingType,
}) => {
  const Constants = INFRAMARK_CONSTANTS.thingTypeDetails.constants;
  const categoryTableHeaders = isEdit
    ? INFRAMARK_CONSTANTS.thingTypeDetails.tableHeaders.category
    : INFRAMARK_CONSTANTS.thingTypeDetails.tableHeaders.category.filter(
        (item) => item.title !== "Actions"
      );
  // const alertResponseTableHeaders = isEdit ? INFRAMARK_CONSTANTS.thingTypeDetails.tableHeaders.alertResponse : INFRAMARK_CONSTANTS.thingTypeDetails.tableHeaders.alertResponse.filter((item) => item.title !== "Actions")
  const [activeTab, setActiveTab] = useState("Category");
  const [isEditable, setIsEditable] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { userProfile } = useContext(UserContext);
  const viewTitle = "Asset Type Category List";
  const alertResponse = INFRAMARK_CONSTANTS.thingTypeDetails.alertResponse;
  const pagesInfo = INFRAMARK_CONSTANTS.thingTypeDetails.displayPages;
  const {
    register,
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      thingType: {
        thingType: "",
        thingTypeId: "",
        displayPage: pagesInfo[0],
        isActive: true,
      },
      thingTypeCategories: [],
      alertResponses: [],
    },
  });

  const {
    fields: categoryFields,
    append: appendCategory,
    remove: removeCategory,
  } = useFieldArray({
    control,
    name: "thingTypeCategories",
  });

  const {
    fields: responseFields,
    append: appendResponse,
    remove: removeResponse,
  } = useFieldArray({
    control,
    name: "alertResponses",
  });

  const [filteredCategories, setFilteredCategories] = useState([]);


  useEffect(() => {
    loadInitialValues();
  }, [selectedThingType, selectedView]);

  function loadInitialValues() {
    setIsEditable(true);
    if (selectedThingType) {
      if (selectedView === Constants.THINGTYPEPREVIEW) {
        setIsEditable(false);
      }
      const typeCategories = selectedThingType.thingTypeCategories?.map(
        (category) => {
          category["modifiedBy"] = userProfile.profile.userid;
          return category;
        }
      );
      const responses = selectedThingType.alertResponses?.map((response) => {
        response["modifiedBy"] = userProfile.profile.userid;
        return response;
      });
      reset({
        thingType: {
          thingTypeId: selectedThingType.thingTypeId,
          thingType: selectedThingType.thingType,
          isActive: selectedThingType.isActive,
          displayPage: selectedThingType.displayPage
            ? {
                label: selectedThingType.displayPage,
                value: selectedThingType.displayPage,
              }
            : pagesInfo[0],
          modifiedBy: userProfile.profile.userid,
        },
        thingTypeCategories: typeCategories ?? [],
        alertResponses: responses ?? [],
      });
    } else {
      reset({
        thingType: {
          thingType: "",
          thingTypeId: "",
          displayPage: pagesInfo[0],
          isActive: true,
          createdBy: userProfile.profile.userid,
        },
        thingTypeCategories: [],
        alertResponses: [],
      });
    }
  }
  const renderTooltip = (props) => {
    return (
      <Tooltip id="button-tooltip" {...props}>
        <div style={{ marginBottom: "0" }}>
          Descriptions can contain a maximum of 50 characters.
        </div>
      </Tooltip>
    );
  };
  const loadNoData = () => {
    return isEditable ? (
      <div className="mt-2 button-empty-row">
        <button
          type="button"
          className="btn-add btn-add-row"
          onClick={() => {
            if (activeTab === "Category") {
              appendCategory({
                thingTypeCategory: "",
                isActive: true,
                createdBy: userProfile.profile.userid,
              });
            } else {
              appendResponse({
                alertResponse: alertResponse[0].value,
                alertResponseMessage: "",
                isActive: true,
                createdBy: userProfile.profile.userid,
              });
            }
          }}
        >
          {`+ Add ${activeTab}`}
        </button>
      </div>
    ) : (
      <h5>{activeTab} list not available</h5>
    );
  };
const getThingTypeKeyByValue = (value) =>{
  for (const key in INFRAMARK_CONSTANTS.thingTypes) {
    if (INFRAMARK_CONSTANTS.thingTypes[key] === value) {
      return key;
    }
  }
  return value; // or undefined, or throw an error, depending on your use case
}
  const onSubmit = (data) => {
    if (
      data.thingType.displayPage &&
      typeof data.thingType.displayPage === "object"
    ) {
      data.thingType.displayPage = data.thingType.displayPage.value;
    }
    data.thingType.thingType = getThingTypeKeyByValue(data.thingType.thingType)
    if (data.thingTypeCategories.length === 0) {
      data.thingTypeCategories = [
        {
          thingTypeCategory: data.thingType.thingType,
          shortDescription: data.thingType.thingType,
          isActive: true,
          createdBy: userProfile.profile.userid,
        },
      ];
    }
    
    const thingTypeCategoriesArray = data.thingTypeCategories.filter(
      (category) => category.thingTypeCategory.length > 0
    );
    data.thingTypeCategories = thingTypeCategoriesArray;
    if (selectedView === Constants.EDITTHINGTYPEVIEW) {
      updateThingType(data);
    } else {
      addNewThingType(data);
    }
  };

  // Function to get the label for a given value
  const getLabelForValue = (value) => {
    const found = alertResponse.find((item) => item.value === value);
    return found ? found.label : "";
  };

  const handleUploadImage = (image_data) => {
    setValue("images", image_data);
  };

  return (
    <>
      <ol
        className="breadcrumb breadcrum-margin"
        style={{ margin: 0, padding: "16px 32px" }}
      >
        <li className="breadcrumb-item">
          <button
            className="breadcrumb-item-custom btn-breadcrum"
            onClick={handleCancel}
            style={{ color: "#1A6BE8", textDecoration: "none" }}
          >
            Asset Type Overview
          </button>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Asset Type Category List
        </li>
      </ol>

      <div
        className="add-group-form-thing list-view-boxshadow"
        style={{ paddingBottom: 8 }}
      >
        <div
          className="col-12 row row-padding-group "
          style={{ paddingBottom: 0 }}
        >
          <div className="view-title-label">
            <h5 className="mb-0 ml-2">{viewTitle}</h5>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-12 mb-4 mt-3 " style={{ padding: "0px" }}>
              {!isEdit && isEditable && (
                <div className="col-sm-12 row mb-4" style={{ padding: "0px" }}>
                  <div className="col-sm-1">
                    <label htmlFor="checkbox"> Active</label>
                  </div>
                  <div className="col-sm-7 toggle" style={{ alignSelf: "end" }}>
                    <label className="switch">
                      <input
                        type="checkbox"
                        {...register("thingType.isActive")}
                        disabled={!isEditable}
                      />
                      {""}
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              )}
              <div className="col-12 row" style={{ padding: "0px" }}>
                <div className="col-8">
                  <div
                    className="form-group__details ml-2"
                    style={{ marginBottom: 0 }}
                  >
                    <label htmlFor="thingType" className="view-label-display">
                      Asset Type: {selectedThingType.thingType}
                    </label>
                  </div>
                  <div className="form-group__details ml-2 mb-0">
                    <label htmlFor="displaypage" className="view-label-display">
                      Display Page:{" "}
                      <Controller
                        name="thingType.displayPage"
                        control={control}
                        render={({ field }) => <>{field.value?.value ?? ""} </>}
                      />
                    </label>
                  </div>
                </div>
                <div
                  className="col-4 row"
                  style={{ columnGap: "16px", alignItems: "center" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      gap: "16px",
                    }}
                  >
                    <div style={{ flex: "1" }}>
                      <div className="input-group">
                        <input
                          className="form-control py-2 border-right-0 border search-asset"
                          type="search"
                          value={searchQuery}
                          placeholder="search category"
                          autoComplete="off"
                          id="example-search-input"
                          onChange={(e) => {
                            setSearchQuery(e.target.value);
                            const result = categoryFields.filter((category) =>
                              category.thingTypeCategory
                                .toLowerCase()
                                .includes(e.target.value.toLowerCase())
                            );
                            setFilteredCategories(result);
                          }}
                        />
                        <span class="input-group-append">
                          <button
                            class="btn btn-outline-secondary border-left-0 border"
                            type="button"
                          >
                            <i class="bi bi-search"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                    <div>
                      <button
                        className={` ${
                          isEdit ? "noborder-btn-edit" : "btn-edit-asset"
                        }`}
                        type="button"
                        onClick={() => {
                          if (selectedThingType.isActive) {
                            handleEditThingType(true);
                            setSearchQuery("");
                          }
                        }}
                        disabled={isEdit}
                        style={{
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="bi bi-pencil-fill"
                          style={{
                            color: `${
                              isEdit ? "rgba(0, 0, 0, 0.38)" : "#ffff"
                            }`,
                          }}
                        ></i>
                        <span style={{ marginLeft: "4px" }}>Edit</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-6"
                  style={{ paddingRight: "24px", display: "none" }}
                >
                  <div className="form-group row row-padding">
                    <label htmlFor="thingType">Asset Type</label>
                    <input
                      id="thingType"
                      className="form-control textbox-style-change"
                      type="text"
                      data-testid="thing-type-input"
                      style={{
                        borderColor: errors?.thingType?.thingType ? "red" : "",
                        marginTop: !isEditable ? "0.5rem" : "0.10rem",
                        backgroundColor: "unset !important",
                      }}
                      {...register("thingType.thingType", { required: true })}
                      disabled={!isEditable}
                      autoComplete="off"
                      autoCorrect="off"
                    />
                  </div>
                </div>
                <div className="col-md-6" style={{ display: "none" }}>
                  <div
                    className="form-group row row-padding"
                    aria-labelledby="display-page-label"
                  >
                    <label htmlFor="displaypage">Display Page</label>
                    <Controller
                      name="thingType.displayPage"
                      control={control}
                      render={({ field }) => (
                        <>
                          {!isEditable ? (
                            <input
                              type="text"
                              className="textbox-style-change"
                              data-testid="display-page-input"
                              value={field.value?.value ?? ""}
                              readOnly
                              style={{ backgroundColor: "unset !important" }}
                            />
                          ) : (
                            <CreatableSelect
                              {...field}
                              options={pagesInfo}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption); // Ensure react-hook-form updates its value
                              }}
                            />
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`bottom-section ${
                getValues("thingType.isActive") ||
                selectedView === Constants.THINGTYPEPREVIEW
                  ? ""
                  : "disabled"
              } table-tab-container`}
              style={{
                height: "calc(100vh - 55vh)",
                overflowY: "auto",
              }}
            >
              <div className="header-admin-thingtype">
                <table>
                  <thead>
                    <tr>
                      {categoryTableHeaders.map((headerItem) => (
                        <th
                          className={`${headerItem.width}`}
                          key={headerItem.title}
                        >
                          {headerItem.title === "Description" ? (
                            <div>
                              Description
                              {isEdit && (
                                <OverlayTrigger
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderTooltip}
                                  placement="right-end"
                                >
                                  <i
                                    className="bi bi-info-circle-fill info-icon-size"
                                    style={{
                                      fontSize: "18px",
                                      padding: "5px",
                                      color: "#1A6BE8",
                                    }}
                                  ></i>
                                </OverlayTrigger>
                              )}
                            </div>
                          ) : (
                            headerItem.title
                          )}
                        </th>
                      ))}
                      {/* {isEdit && <th className="action-column"></th>} */}
                    </tr>
                  </thead>
                  {searchQuery.length === 0 && (
                    <tbody>
                      {categoryFields.map((category, index) => (
                        <tr key={category.id}>
                          <td className="col-4 assetedit-td">
                            <input
                              type="text"
                              className={`form-control  ${
                                !isEdit ? "assetedit-td-noborder" : ""
                              }`}
                              {...register(
                                `thingTypeCategories.${index}.thingTypeCategory`,
                                { required: false }
                              )}
                              maxLength={255}
                              disabled={!isEdit}
                              autoComplete="off"
                              autoCorrect="off"
                            />
                          </td>
                          <td className="col-6 assetedit-td">
                            <input
                              type="text"
                              className={`form-control  ${
                                !isEdit ? "assetedit-td-noborder" : ""
                              }`}
                              {...register(
                                `thingTypeCategories.${index}.shortDescription`,
                                { required: false }
                              )}
                              maxLength={50}
                              disabled={!isEditable}
                              autoComplete="off"
                              autoCorrect="off"
                            />
                          </td>
                          <td className="col-1">
                            {isEdit && (
                              <div className="toggle">
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    {...register(
                                      `thingTypeCategories.${index}.isActive`
                                    )}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            )}
                            {!isEdit && (
                              <div>
                                {category?.isActive ? (
                                  <img
                                    src={Activestatus}
                                    alt="Active"
                                    width={24}
                                  />
                                ) : (
                                  <img
                                    src={inActivestatus}
                                    alt="InActive"
                                    width={24}
                                  />
                                )}
                              </div>
                            )}
                          </td>
                          {/* {isEdit && (
                            <td className="col-1" colSpan={2}>
                              <button
                                disabled={
                                  isEdit &&
                                  selectedThingType?.thingTypeCategories[index]
                                    ?.thingTypeCategory
                                }
                                className="btn-admin-thing"
                                data-testid="trash-button"
                                onClick={() => {
                                  removeCategory(index);
                                }}
                              >
                                <i
                                  className="bi bi-trash3"
                                  style={{
                                    color:
                                      isEdit &&
                                        selectedThingType?.thingTypeCategories[
                                          index
                                        ]?.thingTypeCategory
                                        ? "grey"
                                        : "red",
                                  }}
                                ></i>
                              </button>
                              {index === categoryFields.length - 1 && (
                                <button
                                  className="btn-admin-thing"
                                  onClick={() => {
                                    appendCategory({
                                      thingTypeCategory: "",
                                      isActive: true,
                                      createdBy: userProfile.profile.userid,
                                    });
                                  }}
                                >
                                  <i
                                    className="bi bi-plus-circle h5"
                                    style={{
                                      color: "green",
                                    }}
                                  ></i>
                                </button>
                              )}
                            </td>
                          )} */}
                        </tr>
                      ))}
                      {categoryFields.length <= 0 && (
                        <tr>
                          <td colSpan={4} className="td-empty-row">
                            {loadNoData()}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                  {searchQuery.length > 0 && (
                    <tbody>
                      {filteredCategories.map((category, index) => (
                        <tr key={category.id}>
                          <td className="col-4 assetedit-td">
                            <input
                              type="text"
                              className={`form-control  ${
                                !isEdit ? "assetedit-td-noborder" : ""
                              }`}
                              value={category.thingTypeCategory}
                              maxLength={255}
                              disabled
                              autoComplete="off"
                              autoCorrect="off"
                            />
                          </td>
                          <td className="col-6 assetedit-td">
                            <input
                              type="text"
                              className="form-control"
                              value={category.shortDescription}
                              maxLength={255}
                              disabled
                              autoComplete="off"
                              autoCorrect="off"
                            />
                          </td>
                          <td className="col-1">
                            <div className="toggle">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={category.isActive}
                                  disabled
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {filteredCategories.length <= 0 && (
                        <tr>
                          <td colSpan={4} className="td-empty-row">
                            {loadNoData()}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
                <Tabs
                  id="thing-type-tabs"
                  className="tab-padding"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  style={{ display: "none" }}
                >
                  <Tab eventKey="Category" title="CATEGORIES"></Tab>
                  {/* <Tab eventKey="Response" title="Alert Response">
                <table>
                  <thead>
                    <tr>
                      {alertResponseTableHeaders.map((headerItem) => <th className={`${headerItem.width}`} key={headerItem.title}>{headerItem.title}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {responseFields.map((alert, index) => (
                      <tr key={alert.id}>
                        <td className="col-2">
                          <Controller
                            name={`alertResponses.${index}.alertResponse`}
                            control={control}
                            render={({ field }) => (
                              <>
                                {!isEditable ? (
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={getLabelForValue(field.value)}
                                    readOnly
                                  />
                                ) : (
                                  <select {...field} className="form-control">
                                    {alertResponse.map((option, index) => (
                                      <option key={index} value={option.value}>
                                        {option.label}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </>
                            )}
                          />
                        </td>
                        <td className="col-6">
                          <input
                            type="text"
                            className="form-control"
                            {...register(
                              `alertResponses.${index}.alertResponseMessage`,
                              { required: false }
                            )}
                            disabled={!isEditable}
                            maxLength={50}
                            autoComplete="off"
                            autoCorrect="off"
                          />
                        </td>
                        <td className="col-1">
                          <div className="toggle">
                            <label className="switch">
                              <input
                                type="checkbox"
                                {...register(
                                  `alertResponses.${index}.isActive`
                                )}
                                disabled={!isEditable}
                              />
                              <span className="slider"></span>
                            </label>
                          </div>
                        </td>
                        {isEdit && (
                          <td className="col-1" colSpan={2}>
                            <button
                              className="btn-admin-thing"
                              disabled={
                                isEdit &&
                                selectedThingType?.alertResponses[index]
                                  ?.alertResponse
                              }
                              onClick={() => {
                                removeResponse(index);
                              }}
                            >
                              <i
                                className="bi bi-trash3"
                                style={{
                                  color:
                                    isEdit &&
                                    selectedThingType?.alertResponses[index]
                                      ?.alertResponse
                                      ? "grey"
                                      : "red",
                                }}
                              ></i>
                            </button>
                            {index === responseFields.length - 1 && (
                              <button
                                className="btn-admin-thing"
                                onClick={() => {
                                  appendResponse({
                                    alertResponse: alertResponse[0].value,
                                    alertResponseMessage: "",
                                    isActive: true,
                                    createdBy: userProfile.profile.userid,
                                  });
                                }}
                              >
                                <i
                                  className="bi bi-plus-circle h5"
                                  style={{
                                    color: "green",
                                  }}
                                ></i>
                              </button>
                            )}
                          </td>
                        )}
                      </tr>
                    ))}
                    {responseFields.length <= 0 && (
                      <tr>
                        <td colSpan={4} className="td-empty-row">
                          {loadNoData()}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Tab> */}
                  <Tab eventKey="ThingImage" title="IMAGES">
                    {activeTab !== "ThingImage" ? (
                      <></>
                    ) : (
                      <ThingTypeImage
                        selectedView={selectedView}
                        constants={Constants}
                        control={control}
                        selectedThingType={selectedThingType}
                        fetchAllImages={fetchAllImages}
                        addNewThingTypeImage={
                          selectedView === Constants.ADDTHINGTYPEVIEW
                            ? handleUploadImage
                            : addNewThingTypeImage
                        }
                        updateThingTypeImage={updateThingTypeImage}
                      />
                    )}
                  </Tab>
                </Tabs>
              </div>
            </div>

            {isEdit && (
              <div className="col-12 row btn-div-fixed-asset">
                <div className="col-8"></div>
                <div
                  className="col-4 btn-add-edit"
                  style={{ paddingBottom: "8px" }}
                >
                  <button
                    className="btn btn-light btn-cncl"
                    style={{ textTransform: "uppercase" }}
                    onClick={() => {
                      handleEditThingType(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className=" btn-add-row">
                    Save
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default AddEditThingType;
AddEditThingType.propTypes = {
  selectedView: PropTypes.string.isRequired,
  selectedThingType: PropTypes.object,
  handleCancel: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  addNewThingType: PropTypes.func.isRequired,
  updateThingType: PropTypes.func.isRequired,
  fetchAllImages: PropTypes.func.isRequired,
  addNewThingTypeImage: PropTypes.func.isRequired,
};
